module.exports = __webpack_public_path__ + "static/img/banner.0f6119ee.png";